import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../../lib/site-data";

export default function WhatsappFAB() {
    return (
        <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-40 group"
            aria-label="WhatsApp ile yazın"
            data-testid="whatsapp-fab"
        >
            <span className="absolute inset-0 rounded-full bg-cyan-400/30 blur-xl group-hover:bg-cyan-400/50 transition-all"></span>
            <span className="relative flex items-center gap-2 bg-[#25D366] text-white pl-4 pr-5 py-3 rounded-full shadow-2xl animate-pulse-glow">
                <MessageCircle className="h-5 w-5" />
                <span className="hidden sm:inline text-sm font-medium">WhatsApp</span>
            </span>
        </a>
    );
}
